import { ICreateTokenSaleResponse } from '@entities/trades/token-sell';
import { ITraderWallet } from '@entities/trades/wallet';
import { useMultiStepForm } from '@features/multi-step-form';
import { FormItem } from '@shared/components/Form';
import { useModal } from '@shared/components/Modal';
import RequestStatusLabel from '@shared/components/RequestStatusLabel';

interface IProps<T> {
  wallet: T;
  refetch: () => void;
}

const BANK_FORMATS = ['AXIS', 'YES', 'ESAF', 'ICICI'] as const;

export const StepConfirm = <T extends ITraderWallet>({ wallet, refetch }: IProps<T>) => {
  const { data } = useMultiStepForm<ICreateTokenSaleResponse>();
  const { closeModal } = useModal();

  const handleFinish = () => {
    closeModal();
    refetch();
  };

  const handleDownload = (bank: string) => {
    // TODO: implement download bulk file per bank format
    console.log(`Download bulk file for ${bank}, token sale ${data.id}`);
  };

  return (
    <>
      <h2>Token Sale Created</h2>
      <form className='popup-form'>
        <FormItem name='token_sale_id' label='Trader Order ID'>
          <input type='text' readOnly value={data.id} />
        </FormItem>

        <FormItem name='trader_id' label='Trader ID'>
          <input type='text' readOnly value={data.trader_id} />
        </FormItem>

        <FormItem name='wallet_id' label='Wallet ID'>
          <input type='text' readOnly value={data.trader_wallet_id ?? wallet.id} />
        </FormItem>

        <FormItem name='status' label='Status'>
          <RequestStatusLabel status={data.status ?? 'new'} />
        </FormItem>

        <FormItem name='amount' label='Amount'>
          <input type='text' readOnly value={data.amount} />
        </FormItem>
      </form>

      <div>Download this transaction bulk file in the respective bank format:</div>
      <div>
        {BANK_FORMATS.map(bank => (
          <button key={bank} className='secondary-btn' onClick={() => handleDownload(bank)}>
            {bank}
          </button>
        ))}
      </div>

      <div className='form-submit'>
        <button type='button' onClick={handleFinish}>
          Finish
        </button>
      </div>
    </>
  );
};
